export const getTrainingRevisionNumber = (
  revision: number | null | undefined
): number | null => (revision == null ? null : revision + 1);

export const getTrainingRevisionLabel = (
  revision: number | null | undefined
): string | null => {
  const n = getTrainingRevisionNumber(revision);
  return n == null ? null : `Revision ${n}`;
};

export const getTrainingRevisionShortLabel = (
  revision: number | null | undefined
): string | null => {
  const n = getTrainingRevisionNumber(revision);
  return n == null ? null : `Rev ${n}`;
};
